import Loader from "@/components/loader/Loader.vue";
import {CustomContentMixin} from "@/mixins/CustomContent";
import {OrientationTypes} from "@/enums/OrientationTypes";
//import sidebarDigitalSignage from "@/views/digital-signage/sidebar-digital-signage/SidebarDigitalSignage.vue";

const Handlebars = require('handlebars');

Handlebars.registerHelper('ifStringNotNullOrEmpty', function (value: any) {
    return (value && value.length > 0)
});

export default {
    name: "contentPreview",
    components: {
        Loader,
        //sidebarDigitalSignage
    },
    mixins: [CustomContentMixin],
    data() {
        return {
            loading: true,
            html: null
        }
    },
    computed: {
        currentContent() {
            return this.$store.state.contentCreatorModule.currentContent;
        },
        facility() {
            return this.$store.state.authModule.currentFacilityData;
        },
        eventWings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        isPortrait() {
          return this.currentContent.orientation === OrientationTypes.Portrait;
        },
        isLandscapeSidebar() {
            return this.currentContent.orientation === OrientationTypes.LandscapeSidebar;
        }
    },

    async beforeCreate() {
        if (this.$route.params?.token?.length) {
            await this.$store.dispatch("signInByCustomToken", {
                customToken: this.$route.params.token,
                isExternalPagesViewing: true
            })
        }

        await this.$store.commit("setCurrentFacilityId", this.$route.params.facilityId)

        await this.$store.dispatch("getFacility")

        await this.$store.dispatch("getCurrentCreatorContent", this.$route.params.id)

        await this.$store.dispatch("getEventWings")

        await this.changeTemplate()

        this.loading = false
    },
    methods: {
        async changeTemplate() {
            if (this.currentContent) {
                const stringHtml = this.currentContent?.html;

                if (stringHtml) {
                    const compiledTemplate = Handlebars.compile(stringHtml);
                    let generatedHtml: any = null;

                    await this.getData(stringHtml);
                    generatedHtml = compiledTemplate(this.dataCustomContent);

                    this.html = generatedHtml;
                }
            }
        }
    }
}
